export default __webpack_public_path__ + "static/media/task_actual_time.4487727b.svg";